import api from '../../plugins/api';

// POST /api/crm/onboarding/reset — «Пройти обучение заново».
const resetOnboarding = () => {
  return api.post('/api/crm/onboarding/reset');
};

export default resetOnboarding;
